import { render } from "./Home.vue?vue&type=template&id=1e613e46"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script